<div
    [popper]="popper1Content"
    [popperHideOnClickOutside]="true"
    [popperHideOnScroll]="hideOnScroll"
    [popperTrigger]="NgxPopperjsTriggers.click"
    [popperPlacement]="tooltipPlacement"
    [popperBoundaries]="'body'"
    [popperAppendTo]="'body'"></div>
<popper-content #popper1Content> <span #tooltipMessage></span> </popper-content>
